import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CreateFaqs from "./CreateFaqs";

const CreateFaqsLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Create Faqs" />
      <CreateFaqs />
    </MasterLayout>
  );
};

export default CreateFaqsLayout;
